export * from './app-arc.component';



// WEBPACK FOOTER //
// ./src/app/components/app-arc/index.ts